import React from "react";
import { useNavigate } from "react-router-dom";

import {
  Row,
  Col,
  Space,
  Input,
  Form,
  Card,
  Button,
  Tooltip,
  Checkbox,
} from "antd";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Legend,
  Tooltip as RechartToolTip,
} from "recharts";
import {
  FilterOutlined,
  DownOutlined,
  PlusOutlined,
  SearchOutlined,
  TableOutlined,
  BarChartOutlined,
} from "@ant-design/icons";

const data = [
  {
    name: "Collections review",
    Completed: 100,
    "Due Soon": 200,

    "On Track": 300,
  },
  {
    name: "Ending Management",
    Completed: 100,
    "Due Soon": 398,
    Overdue: 110,
    "On Track": 100,
  },
  {
    name: `P. Bi Weekly Review inspections`,
    Completed: 100,
    "Due Soon": 200,
    Overdue: 100,
    width: 500,
    "On Track": 100,
  },
  {
    name: "N. Violation Notices",
    Completed: 100,
    "Due Soon": 38,
    Overdue: 200,
    "On Track": 150,
  },
  {
    name: "Codebox Pickup",
    Completed: 100,
    "Due Soon": 400,
    Overdue: 211,
    width: 200,
    "On Track": 200,
  },
  {
    name: "New Owner/Property",
    Completed: 100,
    "Due Soon": 300,
    Overdue: 250,
    width: 200,
    "On Track": 300,
  },
  {
    name: "D. Tenant Self Inspections",
    Completed: 100,
    "Due Soon": 30,
    Overdue: 20,
    width: 200,
    "On Track": 300,
  },
  {
    name: "Vacant/Listed property inspection",
    Completed: 100,
    "Due Soon": 3800,
    Overdue: 20,
    width: 200,
    "On Track": 30,
  },
  {
    name: "management fee review",
    Completed: 100,
    "Due Soon": 30,
    Overdue: 2500,
    width: 200,
    "On Track": 30,
  },
  {
    name: "In person inspection",
    Completed: 100,
    "Due Soon": 3800,
    Overdue: 2500,
    width: 200,
    "On Track": 3000,
  },
];
const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    const total = payload.reduce((sum, item) => sum + item.value, 0);
    return (
      <div style={{ backgroundColor: "#fff", padding: "10px" }}>
        <p>{`${label} (${total})`}</p>
        <ul>
          {payload.map((item) => (
            <li key={item.name}>
              <span style={{ color: item.color }}>{`${item.name}: `}</span>
              {`${((item.value / total) * 100).toFixed(2)}%`}
            </li>
          ))}
        </ul>
      </div>
    );
  }
  return null;
};


const ReportsAnalyticsPage = () => {

  const onChange = (e) => {
    console.log(`checked = ${e.target.checked}`);
  };

  const navigate = useNavigate();
  const handlePage =() => {
    navigate('/tasks/reports');
  }
  return (
    <>
      <Row>
        <Col
          span={24}
          style={{ display: "flex", justifyContent: "space-between" }}
        >
          <h1 className="page-heading-report">Workflow Runs <span style={{fontSize:'12px',color:'silver'}}>2,445 results</span></h1>
          <Col>
            <Button
              style={{
                marginRight: "10px",
                border: "none",
                background: "#fffa ",
                borderRadius: "30px",
              }}
              onClick={handlePage}
            >
              <TableOutlined />
              Table
            </Button>
            <Button
              style={{
                border: "none",
                background: "rgba(173,216,230,0.5)",
                borderRadius: "30px",
              }}
            >
              <BarChartOutlined />
              Analytics
            </Button>
          </Col>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
          <Form>
            <Space direction="horizontal">
              <Form.Item name="search">
                <Input
                  prefix={<SearchOutlined className="site-form-item-icon" />}
                  placeholder="Search"
                />
              </Form.Item>
              <Form.Item>
                <Tooltip
                  placement="bottom"
                  title={
                    <div
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#5f7482",
                      }}
                    >
                      <p>No Filters are currentlyapplied</p>
                      <Button>
                        <PlusOutlined /> Add
                      </Button>
                    </div>
                  }
                  trigger={["click"]}
                  color={"white"}
                >
                  <Button>
                    <FilterOutlined />
                    Filters <DownOutlined />
                  </Button>
                </Tooltip>
              </Form.Item>
              <Form.Item>
                <Tooltip
                  placement="bottom"
                  title={
                    <div
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#5f7482",
                      }}
                    >
                      <Form.Item name="search">
                        <Input
                          prefix={
                            <SearchOutlined className="site-form-item-icon" />
                          }
                          placeholder="Search"
                        />
                      </Form.Item>
                      <Col>
                        <Checkbox onChange={onChange}>
                          A. Del City inspection info
                        </Checkbox>
                      </Col>
                      <Col>
                        <Checkbox onChange={onChange}>A. Move Out</Checkbox>
                      </Col>
                      <Col>
                        <Checkbox onChange={onChange}>
                          Application printable
                        </Checkbox>
                      </Col>
                    </div>
                  }
                  trigger={["click"]}
                  color={"white"}
                >
                  <Button>
                    <i
                      className="fa-solid fa-book-open"
                      style={{ marginRight: "5px" }}
                    ></i>
                    All Workflows
                    <DownOutlined />
                  </Button>
                </Tooltip>
              </Form.Item>
              <Form.Item>
                <Button>Apply Changes</Button>
              </Form.Item>
              <Form.Item>
                <Tooltip
                  placement="bottom"
                  title={
                    <div
                      style={{
                        backgroundColor: "white",
                        padding: "10px",
                        color: "#5f7482",
                      }}
                    >
                      <p>Clear</p>
                    </div>
                  }
                  trigger={["click"]}
                  color={"white"}
                >
                  <Button>
                    <DownOutlined />
                  </Button>
                </Tooltip>
              </Form.Item>
            </Space>
          </Form>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Card>
            Workflow Run Completion & Status{" "}
            <i className="fa-solid fa-circle-exclamation"></i>
            <BarChart
              width={1000}
              height={600}
              layout="vertical"
              data={data}
              margin={{ top: 4, bottom: 20, left: 10 }}
              barSize={200}
            >
              <XAxis
                type="number"
                label={{
                  position: "insideBottom",
                  offset: -10,
                  width: 400,
                }}
                style={{ marginTop: "200px" }}
              />

              <YAxis type="category" dataKey="name" width={300} />
              {/* <Tooltip content={renderTooltipContent} /> */}
              <RechartToolTip content={<CustomTooltip />} />
              <Legend legendType="circle" />

              <Bar
                stackId="status"
                dataKey={`On Track`}
                fill="#51a8e4"
                barSize={[5, 10]}
              />
              <Bar
                stackId="status"
                dataKey={`Due Soon`}
                fill="#ffcb33"
                barSize={[5, 10]}
              />
              <Bar
                stackId="status"
                dataKey={`Overdue`}
                fill="#f8798d"
                barSize={[5, 10]}
              />
              <BarChart
                stackId="status"
                dataKey={`Completed`}
                fill="#fbbd08"
                barSize={[5, 10]}
              />
            </BarChart>
          </Card>
        </Col>
      </Row>

      <Row>
        <Col span={24}>
          <Card style={{ marginTop: "20px" }}>
            Workflow Run Status by Assigned User{" "}
            <i className="fa-solid fa-circle-exclamation"> </i>
            <BarChart
              width={1000}
              height={600}
              layout="vertical"
              data={data}
              margin={{ top: 4, bottom: 20, left: 10 }}
              barSize={200}
            >
              <XAxis
                type="number"
                label={{
                  position: "insideBottom",
                  offset: -10,
                  width: 400,
                }}
                style={{ marginTop: "200px" }}
              />

              <YAxis type="category" dataKey="name" width={300} />
              {/* <Tooltip content={renderTooltipContent} /> */}
              <RechartToolTip content={<CustomTooltip />} />
              <Legend legendType="circle" />

              <Bar
                stackId="status"
                dataKey={`On Track`}
                fill="#51a8e4"
                barSize={[5, 10]}
              />
              <Bar
                stackId="status"
                dataKey={`Due Soon`}
                fill="#ffcb33"
                barSize={[5, 10]}
              />
              <Bar
                stackId="status"
                dataKey={`Overdue`}
                fill="#f8798d"
                barSize={[5, 10]}
              />
              <BarChart
                stackId="status"
                dataKey={`Completed`}
                fill="#fbbd08"
                barSize={[5, 10]}
              />
            </BarChart>
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default ReportsAnalyticsPage;
